/**
 *  Add data-toggle_modal="my-modal-id" to a button
 *  Add data-modal_id="my-modal-id" to an element
 *  An inner div is required in the modal element, see example below
 **/
let modal, overlay, modalId, closeBtn

function handleModal(e) {
    if (e.target.dataset.toggle_modal) {
        if (modal && modal.classList.contains('active')) {
            modal.classList.remove('active')
            modal.querySelector('.overlay').remove()
            modal.querySelector('.close-btn').remove()
        } else {
            modalId = e.target.dataset.toggle_modal
            modal = document.querySelector([`[data-modal_id="${modalId}"]`])
            const modalBody = modal.querySelector('div:last-child')

            overlay = /*html*/ `<div class="overlay fixed inset-0 bg-dark/25" data-toggle_modal="${modalId}"></div>`

            closeBtn = /*html*/ `<button class="close-btn absolute flex items-center justify-center w-10 h-10 duration-150 rounded-full right-3 hover:bg-dark/5 active:bg-dark/10 top-3" data-toggle_modal="${modalId}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
            </button>`

            modalBody.insertAdjacentHTML('afterbegin', closeBtn)
            modal.insertAdjacentHTML('afterbegin', overlay)
            modal.classList.toggle('active')
        }
    }
}
document.addEventListener('click', (e) => {
    handleModal(e)
})

document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
        handleModal(e)
    }

    if (e.key === 'Escape') {
        const activeModal = document.querySelector('[data-modal_id].active')
        if (activeModal) {
            activeModal.classList.remove('active')
        }
    }
})

/**
 * 
 * Example:
 * 
<button data-toggle_modal="login">Logga in</button>

<div class="flex items-center justify-center" data-modal_id="login">
    <div class="relative z-10 w-full max-w-lg p-4 bg-white rounded-lg md:p-6 lg:p-8">

    </div>
</div>
*/
